import { Injectable } from '@angular/core';
import { CanActivate, CanActivateFn, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})

// export const authGuard: CanActivateFn = (route, state) => {
//   return true;
// };
export class AuthGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router) { }
 
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const userRole = this.auth.getRole();
    const allowedRoles : string[] =  (route.data['roles'] as string[]) ?? [];
    
    if (allowedRoles.length === 0 || (userRole !== null && allowedRoles.includes(userRole))) {
      return true;
    }

    this.router.navigate(['/no-access']);
    return false;
  }
}  
